export default class Permissions {
    constructor(option) {
        this._permissionsCache = new Map();
        this.apiManager = option.apiManager;
    }

    async query(params) {
        const cacheKey = this._getParamsCacheKey(params);
        const hasCache = this._permissionsCache.has(cacheKey);
        if (hasCache) {
            return this._permissionsCache.get(cacheKey);
        } else {
            const data = await this.apiManager.queryPermission(params);
            this._permissionsCache.set(cacheKey, data);
            return this._permissionsCache.get(cacheKey);
        }
    }

    /**
     * Get cache key for query params.
     * When we have fields value, we use it as our cache key.
     * If the params is null or undefined, we just use sessionId as cache key.
     * @param params - query params.
     * @returns {string} cache key.
     * @private
     */
    _getParamsCacheKey(params) {
        if (
            params &&
            Object.prototype.hasOwnProperty.call(params, 'fields') &&
            params.fields
        ) {
            return this.apiManager.option.sessionId + params.fields;
        } else {
            return this.apiManager.option.sessionId;
        }
    }

    clearCache() {
        this._permissionsCache = new Map();
    }
}
